import { render, staticRenderFns } from "./OthInList.vue?vue&type=template&id=48fcf350"
import script from "./OthInList.vue?vue&type=script&lang=js"
export * from "./OthInList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports